/*
 * @Description: 基础的弹窗组件背景
 * @Author: kadenwang@tencent.com
 * @Date: 2021-11-17 11:48:34
 * @LastEditors: yanxia@tencent.com
 * @LastEditTime: 2022-04-14 19:04:50
 */

import classNames from 'classnames';
import throttle from 'lodash.throttle';
import React, { useEffect, useState } from 'react';
import { postMessageToParent } from '../../lib';
import './index.less';


export interface IBaseModel {
  children: React.ReactNode;
  showLeftModule?: boolean;
  style?: React.CSSProperties;
  onClose?: () => void;
  showClose?: boolean;
  /** 全屏展示 */
  fullScreen?: boolean;
  /** 标题 */
  title?: React.ReactNode;
  /** 描述 */
  description?: React.ReactNode;
  /** 是否展示按钮 */
  showButtons?: boolean;
  /** 确定按钮文案 */
  okText?: React.ReactNode;
  /** 取消按钮文案 */
  cancelText?: React.ReactNode;
  /** 点击确定 */
  onOk?: () => void;
  /** 点击取消 */
  onCancel?: () => void;
}

export const BaseModel: React.FC<IBaseModel> = (props: IBaseModel) => {
  const { children, showLeftModule, style, showClose = true, fullScreen = false, title,
    description, showButtons = false, cancelText, okText, onOk, onCancel } = props;

  const [showMask, setShowMask] = useState(false);

  useEffect(() => {
    const descriptionDom = document.querySelector('.modal-description');

    if (!descriptionDom) return;

    const onScroll = throttle(() => {
      setShowMask(descriptionDom.scrollTop + descriptionDom.clientHeight < descriptionDom.scrollHeight);
    }, 50);

    descriptionDom.addEventListener('scroll', onScroll);
    onScroll();

    return () => {
      descriptionDom.removeEventListener('scroll', onScroll);
    };
  }, [description]);

  return (
    <div className={classNames('login-v2-base-model', { 'full-screen': fullScreen })} style={style}>
      {showLeftModule && <div className="left-module" />}
      <div className="right-module">
        <div className="bar">
          {showClose && <i className="close" onClick={() => postMessageToParent('CLOSE_BASEMODEL', null)} />}
        </div>
        { title && <div className="modal-title">{ title }</div> }
        { description && <div className={classNames('modal-description-wrap', { 'show-mask': showMask })}><div className="modal-description">{ description }</div></div> }
        { children }
        { showButtons && (
          <div className="action">
            { cancelText && <div onClick={onCancel} className="cancel-button button">{ cancelText }</div> }
            { okText && <div onClick={onOk} className="ok-button button">{ okText }</div> }
          </div>
        ) }
      </div>
    </div>
  );
};
